import React from 'react';

interface Props {
  className?: string;
  width?: number;
  height?: number;
  color?: string;
}

const DocumentIcon = ({
  className,
  width = 24,
  height = 24,
  color = 'currentColor',
}: Props) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.54 6.44L14.75 2.48C14.61 2.33 14.41 2.25 14.21 2.25H5.44C4.78 2.25 4.25 2.79 4.25 3.46V19.54C4.25 20.21 4.79 20.75 5.44 20.75H17.55C18.21 20.75 18.74 20.21 18.74 19.54V6.96C18.74 6.77 18.67 6.58 18.53 6.44H18.54ZM17.25 19.25H5.75V3.75H13.88L17.25 7.26V19.25Z"
      fill={color}
    />
    <path d="M13 7.05957H8V8.55957H13V7.05957Z" fill={color} />
    <path d="M15 11.1602H8V12.6602H15V11.1602Z" fill={color} />
    <path d="M15 15.25H8V16.75H15V15.25Z" fill={color} />
  </svg>
);

export default DocumentIcon;
